// Google Analytics - Register Google Analytics page view
up.on('up:location:changed', () => {
  if (typeof ga === "function") {
    ga("set", "page", location.pathname)
    ga("send", "pageview")
  }
})